import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, Badge, UncontrolledDropdown } from "reactstrap"



import axios from 'axios';
import * as url from 'helpers/url_helper';
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { useHistory } from 'react-router-dom';

import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';

import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
  } from "react-bootstrap-table2-paginator";

    const Payroll = () => {
        
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [employees, setEmployees] = useState([])
        const [categories, setCategories] = useState([])
        const [isLoading, setIsLoading] = useState(false)
        const [assigns, setAssigns] = useState([])
        const [deptList, setDeptList] = useState([])
        const [areas, setAreas] = useState([])

        const [sStartDate, setSStartDate] = useState([new Date(new Date().getFullYear(), 0, 1)]);
        const [sEndDate, setSEndDate] = useState([new Date(new Date().getFullYear(), 11, 31)]);
        const [sEmployeeNo, setSEmployeeNo] = useState('') 
        const [sEmployeeName, setSEmployeeName] = useState('')  
        const [sDocumentNo, setSDocumentNo] = useState('')
        const [sDeptId, setSDeptId] = useState('')
        const [sLocationId, setSLocationId] = useState('')
        const [sStatus, setSStatus] = useState('')
        
        const [payrollList, setPayrollList] = useState([])
        const [documentNo, setDocumentNo] = useState('')
        const [payMonth, setPayMonth] = useState('')
        const [status, setStatus] = useState('Draft')
        const [remark, setRemark] = useState('')
        const [id, setId] = useState('')
        
        const [userId, setUserId] = useState('')
        const [username, setUsername] = useState('')
        const [isEdit, setIsEdit] = useState(false)

        const [statusOptions, setStatusOptions]     = useState(['Draft', 'Pending Approval', 'Approved', 'Paid'])
        const [modal_payroll, setmodal_payroll] = useState(false);

        const [employeeOptions, setEmployeeOptions] = useState([])
        
        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
        const tog_payroll = () => {
          setmodal_payroll(!modal_payroll);
          removeBodyCss();
        }
        const fetchData = () => {
          handleFilterData()
        }
        
        useEffect(() => {
          if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setUserId(obj.id);
            setUsername(obj.username)
          }
          fetchData() 
        },[]);

        
        
        const handleFilterData = async () =>{
          const data = {
            id          : '',
            startDate   : formatDate(sStartDate),
            endDate     : formatDate(sEndDate),
            documentNo  : sDocumentNo,
            status      : sStatus,
            action      : 'filter'
         }
         try {
          setIsLoading(true)
          const r = await axios.post(url.HRPAYROLL, JSON.stringify(data), Config)
          setPayrollList(r.data)
         } catch (e) {
          console.log(e)
         } finally {
          setIsLoading(false)
         }
        }
        const handleClearSearch = () =>{
          setLeaveId('')
          setSStartDate([new Date()])
          setSEndDate([new Date()])
          setSDocumentNo('')
          setSStatus('')
          handleFilterData()
        }

        const handleClickAdd = () =>{
          setIsEdit(false)
          setPayMonth('')
          setRemark('')
          setStatus('Open')
          tog_payroll()
        }
        function formatPayMonth(date) {
          const month = String(date.getMonth() + 1).padStart(2, '0'); 
          const year = date.getFullYear();
          return `${year}-${month}`;
        }
        const handleSavePayroll = async () =>{
          const data = {
            id            : isEdit?id:'',
            pay_month     : formatPayMonth(payMonth),
            processed_by  : userId,
            remarks       : remark,
            status        : status,
            action        : isEdit?"edit":"add"
          }
          try {
            setIsLoading(true)
            const r = await axios.post(url.HRPAYROLL, JSON.stringify(data), Config)
            if(r.data.status == 1){
              toastr.success(r.data.message)
              tog_payroll()
              handleFilterData()
            }else{
              toastr.error(r.data.message)
            }
          } catch (e) {
            console.log(e)
          } finally {
            setIsLoading(false)
          }
        }


        const pageOptions = {
          sizePerPage: 10000,
          totalSize: payrollList.length,
          custom: true,
        }
        var node = useRef();
              
        const columns = [
        {
          dataField: 'document_no',
          text: 'No',
          sort: true
        },
        {
          dataField: 'pay_month',
          text: 'Pay Month',
          sort: true
        },
        {
          dataField: 'staff_count',
          text: 'Staff',
          sort: true
        },
        {
          dataField: 'total_allowances',
          text: 'Allowances',
          sort: true,
          formatter: currencyFormatter,
          headerAlign: 'right'
        }, 

        {
          dataField: 'total_deductions',
          text: 'Deductions',
          sort: true,
          formatter: currencyFormatter,
          headerAlign: 'right'
        }, 
        {
          dataField: 'total_net_salary',
          text: 'Total Net',
          sort: true,
          formatter: currencyFormatter,
          headerAlign: 'right'
        }, 
        {
          dataField: 'total_gross_pay',
          text: 'Total Gross',
          sort: true,
          formatter: currencyFormatter,
          headerAlign: 'right'
        }, 
        {
          dataField: 'user_name',
          text: 'Processed By',
          sort: true
        }, 
        {
          dataField: 'updated_at',
          text: 'Processed On',
          sort: true
        }, 
        {
          dataField: 'status',
          text: 'Status',
          sort: true,
          formatter: statusFormatter
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'dateTime',
          order: 'desc'
        }];
        function currencyFormatter(cellContent, row) {
          const formatted = new Intl.NumberFormat().format(cellContent);
          return (
            <div style={{ textAlign: 'right' }}>
              {formatted}
            </div>
          );
        }
 
        function actionFormatter(cellContent, row){
          return(
            <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  onClick={()=>{ 
                      history.push(`/payroll-details/${be.encryptId(row.id)}`)
                    }
                  }
                >
                  Details
            </Button>
          )
        }
        function statusFormatter(cellContent, row) {
          if (cellContent == "Closed") {
            return (
              <div>
                  <Badge className="me-2 bg-success">{ cellContent }</Badge>
              </div>
            );
          }else if(cellContent == "Pending Approval"){
            return (
              <div>
                  <Badge className="me-2 bg-warning">{cellContent}</Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-danger">{ cellContent }</Badge>
              </div>
            );
          }
        }

        
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Payroll | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>

                                <Modal isOpen={modal_payroll} toggle={() => { tog_payroll(); }}  size="l" centered  backdrop={'static'}  >
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`} Payroll</h5>
                                    <button type="button"  onClick={() => { setmodal_payroll(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                      {isEdit && (
                                      <Col md={12}>
                                        <div className="mb-3">
                                            <label>Document No</label>
                                            <input className='form-control' type='text' defaultValue={documentNo} disabled={true}/>
                                        </div>
                                      </Col>
                                      )}
                                 
                          
                                      <Col md={12}>
                                          <div className="mb-3">
                                              <label>Pay Month</label>
                                              <Flatpickr
                                                    className="form-control form-control-sm"
                                                    options={{
                                                    dateFormat: "Y-m", 
                                                    enableTime: false,
                                                    locale: {
                                                        firstDayOfWeek: 1, 
                                                    },
                                                    }}
                                                    value={payMonth}
                                                    onChange={(dates) => setPayMonth(dates[0])}
                                                />
                                          </div>
                                      </Col>
                                      <Col md={12}>
                                          <div className="mb-3">
                                              <label>Status</label>
                                              <select className="form-select" >
                                              <option value="">Draft</option>
                                          
                                              </select>
                                          </div>
                                      </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Remark</label>
                                            <textarea className="form-control form-control" value={remark} onChange={(e)=>setRemark(e.target.value)} />
                                            
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                          <div className="mb-3">
                                              <label>Processed By</label>
                                              <input className='form-control' type='text' defaultValue={username} disabled={true}/>
                                          </div>
                                      </Col>
                                   
                                    </Row>
                                </div>
                                <div className="modal-footer">
                                {isLoading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                    : ( <button type="button" className="btn btn-success" onClick={handleSavePayroll} >Save...</button> )
                                }</div>
                                </Modal> 

                            <Row>
                                      
                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Payroll Filter</h5>
                                <CardBody>
                                <div>
                                    <Row className="mb-3">
                                    <Col xl={6} sm={6}>
                                        <div className="mt-2">
                                        <h5>{``}</h5>
                                        </div>
                                    </Col>

                                    
                                    </Row>
                                </div>
                                                <Row className="justify-content-center mb-1">

                                                    <Col xl={2}>
                                                        <div className="mb-3">
                                                            <label>Start Date</label>
                                                            <Flatpickr
                                                                className="form-control form-control-sm"
                                                                options={{
                                                                dateFormat: "Y-m-d",
                                                                enableTime: false,
                                                                locale: {
                                                                    firstDayOfWeek: 1, 
                                                                },
                                                                }}
                                                                value={sStartDate}
                                                                onChange={(dates) => setSStartDate(dates[0])}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col xl={2}>
                                                        <div className="mb-3">
                                                            <label>End Date</label>
                                                            <Flatpickr
                                                                className="form-control form-control-sm"
                                                                options={{
                                                                dateFormat: "Y-m-d",
                                                                enableTime: false,
                                                                locale: {
                                                                    firstDayOfWeek: 1, 
                                                                },
                                                                }}
                                                                value={sEndDate}
                                                                onChange={(dates) => setSEndDate(dates[0])}
                                                            />
                                                        </div>
                                                    </Col>
                                                   
                                                    <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Document No</label>
                                                          <input type='text' className="form-control form-control-sm" value={sDocumentNo} onChange={(e)=>setSDocumentNo(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Status</label>
                                                          <select className="form-select form-select-sm" value={sStatus} onChange={(e)=>setSStatus(e.target.value)}>
                                                              <option value="">All</option>
                                                              {(statusOptions || []).map((e,k)=>(
                                                                <option value={e} key={k}>{e}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Processed by</label>
                                                          <input type='text' className="form-control form-control-sm"  />
                                                          
                                                      </div>
                                                  </Col>
                                                </Row>
                             
                                                <Row  className="justify-content-center mb-2">
                                                <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                    <div className="d-grid gap-2">
                                                      <Button
                                                        color='warning'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClearSearch()}}
                                                      >
                                                        <i className="mdi mdi-notification-clear-all me-1" />
                                                        Reset search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                    <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClickAdd()}}
                                                        
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Create Payroll
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                                </CardBody>
                                                </Card>
                                                <Card>
                                                <h5 className="card-header bg-transparent border-bottom text-uppercase">Payrolls ({payrollList.length})</h5>
                                                  <CardBody>

                                                                                             
                                {(payrollList.length > 0) && (
                                    <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField="id"
                                    columns={columns}
                                    data={payrollList}
                                    >
                                    {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                      keyField="id"
                                      data={ payrollList }
                                      columns={ columns }
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                              
                                            <Row>
                                              <Col xl="12">
                                                
                                              <div className="table-responsive">
                                                <BootstrapTable 
                                                  
                                                  keyField='id' 
                                                  data={ payrollList } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                  style={{ backgroundColor: 'white' }}
                                                    {...toolkitProps.baseProps}
                                                    {...paginationTableProps}
                                                  ref={node}
                                                  />
                                                  </div>
                                            
                                            </Col>
                                            </Row>
                                            <Row className="align-items-md-center mt-30">
                                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                                <PaginationListStandalone
                                                  {...paginationProps}
                                                />
                                              </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                    </ToolkitProvider>
                                    )}
                                    </PaginationProvider>
                                    )}
                                    {((payrollList || []).length < 1) && (
                                    <div className="text-center">
                                      <div className="mb-4">
                                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                      </div>
                                      <div>
                                      { isLoading ? <h5>Please Wait...</h5> : <h5>No data</h5> }
                                      <p className="text-muted">
                                              
                                      </p>
                                      </div>
                                      <div className="text-center mt-4">
                                        <Link
                                        to="#"
                                        onClick={()=>{handleClickAdd()}}
                                       
                                        className="btn btn-primary  btn-sm"
                                        >
                                        Create Payroll <i className="mdi mdi-arrow-right ms-1" />
                                        </Link>
                                    </div>
                                    </div>
                                    

                                    )}


                                </CardBody>
                            </Card>
                            </Col>

                           
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default Payroll;